import { html, LitElement, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import '../Ripple/Ripple';

import styles from './MenuItem.scss?inline';

@customElement('app-menu-item-dumb')
export class MenuItem extends LitElement {
    static styles = [unsafeCSS(styles)];

    render() {
        return html`
            <div class='touch-target' tabindex=0>
                <div class='visual-container'>
                    <app-ripple></app-ripple>
                    <slot name='start' class='start'></slot>
                    <slot></slot>
                    <slot name='end' class='end'></slot>
                </div>
            </div>
        `
    }
}